<div id="container-compartment-details" class="container-compartment">
  <div class="modal-header">
    <h1
      class="modal-title container-compartment-title"
      *ngIf="getOperationDescription() === 'Add'; else isEdit"
    >
      {{ 'COMPARTMENT-DETAILS.ADD-TEXT' | translate }}
      {{
        this.editMode
          ? this.compartment?.compartmentNumber
          : this.nextCompartmentNumber
      }}
    </h1>
    <ng-template #isEdit>
      <h1 class="modal-title container-compartment-title">
        {{ 'COMPARTMENT-DETAILS.EDIT-TEXT' | translate }}
        {{
          this.editMode
            ? this.compartment?.compartmentNumber
            : this.nextCompartmentNumber
        }}
      </h1>
    </ng-template>
  </div>

  <form class="modal-body" [formGroup]="containerCompartmentForm">
    <mat-form-field
      floatLabel="always"
      *ngIf="this.containerCompartmentForm.get('PreviousProduct1')"
    >
      <input
        matInput
        ymsWeightValidation
        type="text"
        id="compartmentCapacity"
        name="SizeOfCompartments"
        placeholder="{{ 'COMPARTMENT-DETAILS.CAPACITY' | translate }}"
        [appFormatDirective]="'^[1-9][0-9]*$'"
        [(ngModel)]="this.compartment.compartmentCapacity"
        formControlName="SizeOfCompartments"
      />
      <mat-error
        *ngIf="
          containerCompartmentForm.hasError('required', 'SizeOfCompartments')
        "
        >{{ 'COMPARTMENT-DETAILS.CAPACITY-REQUIRED' | translate }}</mat-error
      >
      <mat-error
        *ngIf="
          containerCompartmentForm.hasError('weight', 'SizeOfCompartments')
        "
        >{{ 'COMPARTMENT-DETAILS.CAPACITY-INVALID' | translate }}</mat-error
      >
    </mat-form-field>

    <div class="row">
      <div class="col-8">
        <mat-form-field
          floatLabel="always"
          *ngIf="this.containerCompartmentForm.get('PreviousProduct1')"
        >
          <input
            matInput
            type="text"
            id="previousProduct1"
            name="previousProduct1"
            placeholder="{{
              'COMPARTMENT-DETAILS.PREVIOUS-PRODUCT-1' | translate
            }}"
            [(ngModel)]="this.compartment.previousProduct1"
            formControlName="PreviousProduct1"
          />
          <mat-error
            *ngIf="
              containerCompartmentForm.hasError('required', 'PreviousProduct1')
            "
            >{{
              'COMPARTMENT-DETAILS.PREVIOUS-PRODUCT-1-REQUIRED' | translate
            }}</mat-error
          >
        </mat-form-field>
      </div>
      <div class="col-4">
        <mat-form-field
          floatLabel="always"
          *ngIf="this.containerCompartmentForm.get('IDTF1')"
        >
          <input
            matInput
            type="text"
            id="IDTF1"
            name="IDTF1"
            placeholder="IDTF1"
            [appFormatDirective]="'^((?=.{0,5}$)[0-9]){1,5}$'"
            [(ngModel)]="this.compartment.idtF1"
            formControlName="IDTF1"
            pattern="\d{5}"
          />
          <mat-error
            *ngIf="containerCompartmentForm.hasError('required', 'IDTF1')"
            >{{ 'COMPARTMENT-DETAILS.FIELD-REQUIRED' | translate }}</mat-error
          >
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-8">
        <mat-form-field
          floatLabel="always"
          *ngIf="this.containerCompartmentForm.get('PreviousProduct2')"
        >
          <input
            matInput
            type="text"
            id="previousProduct2"
            name="previousProduct2"
            placeholder="{{
              'COMPARTMENT-DETAILS.PREVIOUS-PRODUCT-2' | translate
            }}"
            [(ngModel)]="this.compartment.previousProduct2"
            formControlName="PreviousProduct2"
          />
          <mat-error
            *ngIf="
              containerCompartmentForm.hasError('required', 'PreviousProduct2')
            "
            >{{
              'COMPARTMENT-DETAILS.PREVIOUS-PRODUCT-2-REQUIRED' | translate
            }}</mat-error
          >
        </mat-form-field>
      </div>
      <div class="col-4">
        <mat-form-field
          floatLabel="always"
          *ngIf="this.containerCompartmentForm.get('IDTF2')"
        >
          <input
            matInput
            type="text"
            id="IDTF2"
            name="IDTF2"
            placeholder="IDTF2"
            [appFormatDirective]="'^((?=.{0,5}$)[0-9]){1,5}$'"
            [(ngModel)]="this.compartment.idtF2"
            formControlName="IDTF2"
            pattern="\d{5}"
          />
          <mat-error
            *ngIf="containerCompartmentForm.hasError('required', 'IDTF2')"
            >{{ 'COMPARTMENT-DETAILS.FIELD-REQUIRED' | translate }}</mat-error
          >
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-8">
        <mat-form-field
          floatLabel="always"
          *ngIf="this.containerCompartmentForm.get('PreviousProduct3')"
        >
          <input
            matInput
            type="text"
            id="previousProduct3"
            name="previousProduct3"
            placeholder="{{
              'COMPARTMENT-DETAILS.PREVIOUS-PRODUCT-3' | translate
            }}"
            [(ngModel)]="this.compartment.previousProduct3"
            formControlName="PreviousProduct3"
          />
          <mat-error
            *ngIf="
              containerCompartmentForm.hasError('required', 'PreviousProduct3')
            "
            >{{
              'COMPARTMENT-DETAILS.PREVIOUS-PRODUCT-3-REQUIRED' | translate
            }}</mat-error
          >
        </mat-form-field>
      </div>
      <div class="col-4">
        <mat-form-field
          floatLabel="always"
          *ngIf="this.containerCompartmentForm.get('IDTF3')"
        >
          <input
            matInput
            type="text"
            id="IDTF3"
            name="IDTF3"
            placeholder="IDTF3"
            [appFormatDirective]="'^((?=.{0,5}$)[0-9]){1,5}$'"
            [(ngModel)]="this.compartment.idtF3"
            formControlName="IDTF3"
            pattern="\d{5}"
          />
          <mat-error
            *ngIf="containerCompartmentForm.hasError('required', 'IDTF3')"
            >{{ 'COMPARTMENT-DETAILS.FIELD-REQUIRED' | translate }}</mat-error
          >
        </mat-form-field>
      </div>
    </div>
  </form>
  <div class="modal-footer">
    <button
      type="submit"
      class="btn btn-success answer-button"
      (click)="confirmAction()"
    >
      {{ getOperationDescription() }}
    </button>
    <button
      type="button"
      class="btn btn-outline-dark answer-button"
      (click)="this.activeModal.close(null)"
    >
      {{ 'SHARED.MODAL-CANCEL' | translate }}
    </button>
  </div>
</div>
